export enum RolesEnum {
  REPORT = 'Wally.Report',
  TETRIS_DEV = 'Tetris.Developer',
}
